<template>
  <span
    v-if="field.$errors.length"
    class="text-sm font-semibold text-red-500 input-error"
  >
    <p>{{ field.$errors[0].$message }}</p>
  </span>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  props: ["field"],
  setup() {
    return {};
  },
});
</script>

<style scoped></style>
